import React from "react";
import { useArticleImage } from "./useArticleImage";

export const StoryImage = ({ image, headline, className = "", testId = "story-image" }) => {
  const { available, onError } = useArticleImage(image);
  if (!available) return <div className={`${className} grid place-items-center bg-[var(--ink-2)] text-white/30`} role="img" data-testid={`${testId}-placeholder`} aria-label="No article image available"><span className="font-serif text-3xl">DNH</span></div>;
  return <img src={image} alt={headline || "News reporting"} loading="lazy" decoding="async" onError={onError} className={`${className} object-cover`} data-testid={testId} />;
};